
(function ( $ ) {

   $.fn.newsletter = function( options ) {
     var that = this;

     function submitForm() {

        $('[data-error]').removeClass('has-error');
       console.log($('.js-loader'));
        $('.js-loader').addClass('is-visible');
        that.find('button[type="submit"]').prop('disabled', 'disabled');
        var data = new FormData(that[0]);
        data.append('action', 'captcha_verification');        

        $('.js-footer-error-message').hide();

        $.ajax({
          url: ajaxurl,
          data: data,
          processData: false,
          contentType: false,
          type: 'POST',
          success: function (data) {
            postForm();
          },
          error: function (data) {
            that.find('button[type="submit"]').prop('disabled', false);
            var error = data.responseJSON.message;
            $('.js-loader').removeClass('is-visible');
            $('.js-footer-error-message').html(error);
            $('.js-footer-error-message').fadeIn();
            grecaptcha.reset();
          }
        });

        function postForm() {
          data.append('action', 'newsletter');
          $.ajax({
            url: ajaxurl,
            data: data,
            processData: false,
            contentType: false,
            type: 'POST',
            success:function(data){
              that.find('button[type="submit"]').prop('disabled', 'disabled');
              $('.js-footer-error-message').hide();
              $('.js-footer-validation-message').show();
              $('.js-btn-validation').show();
              $('.js-btn-sumbmit').hide();
              $('.js-loader').removeClass('is-visible');

              setTimeout(function () {
                $('#newsletter-modal').removeClass('is-open');
              }, 2000);
            },
            error: function(xhr, status, error) {
              grecaptcha.reset();
              Object.keys(xhr.responseJSON).map(function(key) {
                $('[data-error="' + key + '"]').addClass('has-error');
                $('[data-error="' + key + '"]').velocity({scale:"0.99"}).velocity({scale:"1"}, {easing: "spring"});
              });
              that.find('button[type="submit"]').prop('disabled', false);
              $('.js-footer-error-message').html(xhr.responseJSON.footer_email);
              $('.js-footer-error-message').fadeIn();
              $('.js-progress').removeClass('animated');
              $('.js-loader').removeClass('is-visible');
            }
          });
        }

      }

     if (this.length) {
      return this.submit(function(e){
        e.preventDefault();
        submitForm();
      });
     }
   }

}( jQuery ));

$(function() {
 $('#js-newsletter').newsletter();
});